module.exports = __webpack_public_path__ + "27670c535824abb6ae7263d60fdc8a86.png";